import i18n from '@/i18n';
import { PROGRESS_STEP_KINDS } from '@/config/constants';

export default {
  // External steps are named by their publisher, the others are MyLab's own and translated.
  label(step) {
    return step.kind === PROGRESS_STEP_KINDS.EXTERNAL
      ? step.label
      : i18n.t(`sampleProgress.steps.${step.kind}`);
  },
};
